import ConversationPinsAPI from 'dashboard/api/conversationPins';

const scopeKey = getters =>
  `${getters.getCurrentUserID}:${getters.getCurrentAccountId}`;

// Keep personal metadata separate from shared conversation websocket payloads.
export default {
  namespaced: true,
  state: () => ({ records: {}, pending: {} }),
  getters: {
    currentPins: (state, getters, rootState, rootGetters) =>
      state.records[scopeKey(rootGetters)] || {},
    isUpdating: (state, getters, rootState, rootGetters) => conversationId =>
      !!state.pending[`${scopeKey(rootGetters)}:${conversationId}`],
  },
  mutations: {
    setPins(state, { scope, pins }) {
      state.records[scope] = Object.fromEntries(
        pins.map(pin => [pin.conversation_id, pin.pinned_at])
      );
    },
    setPin(state, { scope, conversationId, pinnedAt }) {
      state.records[scope] ||= {};
      if (pinnedAt) {
        state.records[scope][conversationId] = pinnedAt;
      } else {
        delete state.records[scope][conversationId];
      }
    },
    setPending(state, { key, value }) {
      state.pending[key] = value;
    },
  },
  actions: {
    async get({ commit, rootGetters }) {
      const scope = scopeKey(rootGetters);
      const { data } = await ConversationPinsAPI.get();
      commit('setPins', { scope, pins: data });
    },
    async set(
      { state, commit, rootGetters },
      { conversationId, pinned, forAll = false }
    ) {
      const scope = scopeKey(rootGetters);
      const key = `${scope}:${conversationId}`;
      if (state.pending[key]) return;
      commit('setPending', { key, value: true });
      try {
        let pinnedAt = null;
        if (pinned) {
          const { data } = await ConversationPinsAPI.create({
            conversation_id: conversationId,
            scope: forAll ? 'all' : 'me',
          });
          pinnedAt = data.pinned_at;
        } else {
          await ConversationPinsAPI.delete(conversationId);
        }
        commit('setPin', { scope, conversationId, pinnedAt });
      } finally {
        commit('setPending', { key, value: false });
      }
    },
  },
};
